module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Related Widget

(function (fox){
	'use strict';

	fox.registerWidget('Content_Related', {
		configure: function (options) {
			this.callParent('configure', arguments);

			this.registerOptions('', {
				widgets: {
					contentList: {
						widget: 'Content_Browser'
					}
				},
				handleWom: {
					contentIdSetting: {
						widget: '@parent',
						event: 'setContentId',
						callback: '_handleContentIdSetting'
					},
					activatingSceneViewer: {
						widget: '@parent',
						event: 'activateSceneViewer',
						callback: '_handleContentIdSetting'
					}
				}
			});
		},

		running: function (argument) {
			this.contentList = this.wom1('#contentList');

			this.callParent('running', arguments);
		},

		_handleContentIdSetting: function (id, w, e) {
			this.loadRelatedContent(id);
		},

		loadRelatedContent: function (excludedId) {
			this.contentList.dl.dropFilter('exclude');
			
			this.contentList.dl.addFilter('exclude', {
				fields: ['!id'],
				values: [[excludedId]]
			}).load();
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/content/related.js
// module id = 856
// module chunks = 4